export default "__VITE_ASSET__DEVc8A7___"